<template>
  <div class="nerv-readout" :class="tone ? `tone-${tone}` : ''">
    <span class="nerv-readout-label">{{ label }}</span>
    <span class="nerv-readout-value nerv-phosphor">
      {{ value }}<span v-if="unit" class="nerv-readout-unit">{{ unit }}</span>
    </span>
    <span v-if="note" class="nerv-caption">{{ note }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'NervReadout',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    unit: { type: String, default: '' },
    note: { type: String, default: '' },
    tone: { type: String as PropType<'cyan' | 'magenta' | 'green' | ''>, default: '' },
  },
});
</script>
